import { Alert, Backdrop, CircularProgress, Typography } from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';
import { Theme } from '@mui/system';
import { useDialog } from 'muibox';
import { useContext, useEffect, useState } from 'react';
import { Link, NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import BackNavigationButton from '../../../components/common/BackNavigationButton';
import PageContainer from '../../../components/common/PageContainter';
import ServiceActionsBlocks from '../../../components/common/ServiceActions';
import { SettingsContext } from '../../../store/SettingsContext';
import { UserContext } from '../../../store/UserContext';
import { handleHttpError, handleHttpErrorResponse } from '../../../utils/common';

const HostessOverview = () => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const theme: Theme = useTheme();
    const navigate: NavigateFunction = useNavigate();
    const dialog = useDialog();
    const params = useParams();
    const [showBackdrop, setShowBackdrop] = useState<boolean>(false);

    const [subscriber, setSubscriber] = useState<any | null>(null);

    useEffect(() => {
        if (userContext.jwtToken && settingsContext.apiKey && 'userId' in params && params.userId) {
            const query: string = `${settingsContext.routes.subscribers.find}${params.userId}`;

            fetch(query, {
                method: 'get',
                headers: {
                    Authorization: userContext.jwtToken,
                    apiKey: settingsContext.apiKey,
                },
            })
                .then(async response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        handleHttpErrorResponse(response, dialog);
                    }
                })
                .then(data => {
                    setSubscriber(data);
                    setShowBackdrop(false);

                    if (!data || !('_id' in data) || !data._id) {
                        navigate('/');
                    }
                })
                .catch(error => {
                    console.error(error);
                    handleHttpError(error, dialog);
                });
        }
    }, [userContext, settingsContext, params, dialog, navigate]);

    return (
        <PageContainer>
            {subscriber && '_id' in subscriber && subscriber._id && (
                <>
                    <Typography variant="h5" sx={{ marginBottom: theme.spacing(2) }}>
                        <BackNavigationButton {...(subscriber && { url: `/subscribers/${subscriber._id}` })} /> Hostess Overview for{' '}
                        {subscriber.username}
                    </Typography>

                    <Alert severity="info" sx={{ marginBottom: theme.spacing(2) }}>
                        Please make sure you read the{' '}
                        <Link
                            to={`/subscribers/${subscriber._id}/hostess/welcome`}
                            style={{ color: theme.palette.primary.main, textDecoration: 'none' }}
                        >
                            <strong>Welcome</strong>
                        </Link>{' '}
                        information first!
                    </Alert>

                    <ServiceActionsBlocks actions={settingsContext.services.hostess.actions} subscriber={subscriber} theme={theme} />
                </>
            )}
            <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={showBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </PageContainer>
    );
};

export default HostessOverview;
